import { memo } from 'react';

import HighlightText from './Highlight';
import type { JsonNodeProps, JsonValue } from './JsonViewer.helpers';

const JsonNode = memo(({ value, indent = 0, highlight = '' }: JsonNodeProps) => {
	const pad = '  '.repeat(indent);
	const inner = '  '.repeat(indent + 1);

	if (value === null) return <span className='jv-null'>null</span>;
	if (typeof value === 'boolean') return <span className='jv-bool'>{String(value)}</span>;
	if (typeof value === 'number') return <span className='jv-num'>{value}</span>;
	if (typeof value === 'string')
		return (
			<span className='jv-str'>
				"
				<HighlightText
					text={value}
					highlight={highlight}
				/>
				"
			</span>
		);

	const isArray = Array.isArray(value);
	const entries = isArray ? value.map((v, i) => [i, v] as [number, JsonValue]) : Object.entries(value);

	return (
		<>
			<span className='jv-punct'>{isArray ? '[' : '{'}</span>
			{'\n'}
			{entries.map(([k, v], i) => (
				<span
					key={k}
					className='jv-line'
				>
					{inner}
					{!isArray && (
						<>
							<span className='jv-key'>
								"
								<HighlightText
									text={String(k)}
									highlight={highlight}
								/>
								"
							</span>
							<span className='jv-punct'>: </span>
						</>
					)}
					<JsonNode
						value={v}
						indent={indent + 1}
						highlight={highlight}
					/>
					{i < entries.length - 1 && <span className='jv-punct'>,</span>}
					{'\n'}
				</span>
			))}
			<span className='jv-line'>
				{pad}
				<span className='jv-punct'>{isArray ? ']' : '}'}</span>
			</span>
		</>
	);
});

JsonNode.displayName = 'JsonNode';

export default JsonNode;
